<template>
    <section class="phototheme_box" aria-labelledby="catalog-heading">
        <p class="phototheme-title">PHOTOGRAPHIC THEME</p>
        <h2 id="catalog-heading" class="phototheme-subtitle">拍摄主题</h2>
        <div v-if="catalogStatus === catalogStatuses.IDLE || catalogStatus === catalogStatuses.LOADING" class="catalog-state" role="status" aria-live="polite">
            <i class="el-icon-loading catalog-state__icon" aria-hidden="true"></i>
            <h3>正在加载摄影服务</h3>
            <p>正在获取当前可售的主题与风格，请稍候。</p>
        </div>
        <div v-else-if="catalogStatus === catalogStatuses.EMPTY" class="catalog-state" role="status">
            <i class="el-icon-camera catalog-state__icon" aria-hidden="true"></i>
            <h3>暂无可售摄影服务</h3>
            <p>目录正在更新中，稍后再来看看吧。</p>
        </div>
        <div v-else-if="catalogStatus === catalogStatuses.SESSION_EXPIRED" class="catalog-state" role="alert">
            <i class="el-icon-user catalog-state__icon" aria-hidden="true"></i>
            <h3>登录会话已失效</h3>
            <p>{{catalogError || '请重新登录后继续浏览摄影服务。'}}</p>
            <div><el-button type="primary" @click="goToLogin">重新登录</el-button><el-button @click="retryCatalog">重试加载</el-button></div>
        </div>
        <div v-else-if="catalogStatus === catalogStatuses.ERROR" class="catalog-state" role="alert">
            <i class="el-icon-warning-outline catalog-state__icon" aria-hidden="true"></i>
            <h3>目录加载失败</h3>
            <p>{{catalogError}}</p>
            <el-button type="primary" @click="retryCatalog">重新加载</el-button>
        </div>

        <template v-else>
            <photograph-theme-item
                v-for="group in catalogGroups"
                :key="group.id"
                :theme-type-id="group.id"
                :theme-data="group.themes">
                <template v-slot:title>
                    <div class="phototheme-item-title">{{group.name}} / {{group.englishName}}</div>
                </template>
            </photograph-theme-item>
        </template>
    </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import photographyCatalog from "@/tool/photographyCatalog.cjs";

const { PHOTOGRAPHY_CATALOG_STATUS } = photographyCatalog;

export default {
    data() {
        return {
            catalogStatuses: PHOTOGRAPHY_CATALOG_STATUS,
        };
    },
    computed: {
        ...mapState({
            themeTypes: (state) => state.photography.catalog.themeTypes,
            catalogStatus: (state) => state.photography.catalogStatus,
            catalogError: (state) => state.photography.catalogError,
        }),
        catalogGroups() {
            return this.themeTypes.map((themeType) => ({
                id: themeType.id,
                name: themeType.name,
                englishName: this.englishThemeName(themeType.name),
                themes: themeType.themes,
            })).filter((group) => group.themes.length);
        },
    },
    components: { photographThemeItem: () => import("@/components/photographThemeItem") },
    methods: {
        ...mapActions(["loadPhotographyCatalog"]),
        englishThemeName(name) {
            if (name.includes("校园")) return "Campus Photography";
            if (name.includes("个人") || name.includes("家庭")) return "Family Photography";
            if (name.includes("商业")) return "Commercial Photography";
            if (name.includes("视频")) return "Video Services";
            if (name.includes("传统") || name.includes("工艺")) return "Classic Photography";
            return "Photography";
        },
        retryCatalog() { this.loadPhotographyCatalog().catch(() => {}); },
        goToLogin() {
            this.$router.push({ name: "login", query: { redirect: this.$route.fullPath } });
        },
    },
};
</script>

<style scoped>
.phototheme_box{ margin-top: 70px; color: #303133; text-align: center; }
.phototheme-title{ margin: 0; color: #303133; font-size: 40px; font-weight: bold; }
.phototheme-subtitle{ margin: 0 0 20px; font-size: 30px; font-weight: normal; }
.catalog-state{ min-height: 260px; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 40px 20px; background: #fff; border: 1px solid #ebeaf1; border-radius: 14px; text-align: center; }
.catalog-state__icon{ margin-bottom: 12px; color: #8d9afc; font-size: 34px; }
.catalog-state h3{ margin: 0 0 8px; font-size: 20px; }
.catalog-state p{ margin: 0 0 20px; color: #7a7783; }
.phototheme-item-title{ padding: 20px 10px; color: #303133; font-size: 20px; }
@media (max-width: 767px){
    .phototheme_box{ margin-top: 42px; padding: 0 12px; }
    .phototheme-title{ font-size: 30px; }
    .phototheme-subtitle{ font-size: 25px; }
}
</style>
